<template>
  <section>
    <b-card
      no-body
      class="card-employee-task"
    >
      <!-- Header -->
      <b-card-header>
        <b-card-title>
          Compañeros de curso
          <br>
          <small><b>{{ totalItems }}</b> alumnos encontrados</small>
        </b-card-title>
        <b-card-text class="font-small-2 mr-25 mb-0">
          Datos cargados <b>{{ updatedAt }}</b>
        </b-card-text>
      </b-card-header>

      <!-- Table Top -->
      <div class="mx-2">
        <b-row>
          <!-- Cantidad de elementos por página -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <small>Mostrar</small>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
          </b-col>

          <!-- Buscador -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <feather-icon
                    :class="{ 'text-danger cursor-pointer': searchQuery != '' }"
                    :icon="searchQuery != '' ? 'XIcon' : 'SearchIcon'"
                    @click="searchQuery != '' ? searchQuery = '' : ''"
                  />
                </b-input-group-prepend>
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Buscar"
                  size="sm"
                />
              </b-input-group>
            </div>
          </b-col>
        </b-row>
      </div>

      <!-- Data & pagination -->
      <b-overlay
        :show="isBusy"
        rounded="sm"
      >
        <!-- body -->
        <b-card-body>
          <div v-if="temporalClassmates.length">
            <div
              v-for="mate in temporalClassmates"
              :key="mate.idPersona"
              class="employee-task d-flex justify-content-between align-items-center"
            >
              <b-media no-body>
                <b-media-aside class="mr-75">
                  <b-avatar
                    rounded
                    size="33"
                    variant="light-primary"
                    :src="require(`@/assets/images/icons/avatar-user-${mate.genero === 'F' ? 'female' : 'male'}.svg`)"
                  />
                </b-media-aside>
                <b-media-body class="my-auto">
                  <h6 class="mb-0">
                    {{ mate.nombre }}
                  </h6>
                  <small @click="personSelected = mate.idPersona; personSelected = mate; shallShowEmailComposeModal = true">
                    <a href="#">{{ mate.email }}</a>
                  </small>
                </b-media-body>
              </b-media>
            </div>
          </div>
          <div
            v-else
            class="text-center text-muted m-1"
          >
            <small>Sin resultados</small>
          </div>
        </b-card-body>

        <!-- Pagination -->
        <div class="mx-2 mb-2">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalItems"
            :per-page="perPage"
            first-number
            last-number
            size="sm"
            align="right"
            class="mb-0 mt-1 mt-sm-0"
          />
        </div>
      </b-overlay>
    </b-card>

    <!-- Compose Email Modal -->
    <email-compose
      v-model="shallShowEmailComposeModal"
      :compose-to="(personSelected) ? personSelected.idPersona : null"
      :data-request="{ action: 9, task: 'wsalumno' }"
    >
      <template #to>
        <div class="compose-mail-form-field mx-2 my-1">
          <span
            for="email-to"
            class="form-label font-weight-bolder"
          >Para: </span>
          <b-badge variant="light-primary">
            {{ (personSelected) ? `${personSelected.nombre} - ${personSelected.email}` : '' }}
          </b-badge>
        </div>
        <hr>
      </template>
    </email-compose>
  </section>
</template>

<script>
import {
  BCard,
  BCardTitle,
  BCardText,
  BCardHeader,
  BCardBody,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BPagination,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BOverlay,
  BBadge,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { lastUpdate } from '@core/utils/filter'
import { ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import EmailCompose from '@core/components/email-compose/EmailCompose.vue'
import { useRouter } from '@core/utils/utils'
import { configListClassmate } from '../../useAlumno'

export default {
  components: {
    BCard,
    BCardTitle,
    BCardText,
    BCardHeader,
    BCardBody,
    BMedia,
    BMediaAside,
    BMediaBody,
    BAvatar,
    BPagination,
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BOverlay,
    BBadge,
    vSelect,

    EmailCompose,
  },
  setup() {
    const toast = useToast()
    const updatedAt = ref(lastUpdate())
    const { route } = useRouter() //* Use router propieties
    const shallShowEmailComposeModal = ref(false)
    // const personSelected = ref(null)
    const personSelected = ref(null)
    const {
      //* Fetching data
      fetchData, classmates, temporalClassmates,
      //* Basic filters & pagination
      perPage, totalItems, currentPage, perPageOptions, searchQuery,
      //* Loader
      isBusy,
    } = configListClassmate()
    //* Load classmates
    const loadClassmates = () => {
      isBusy.value = true
      fetchData(route.value.params.curso).then(() => {
        isBusy.value = false
      }, error => {
        isBusy.value = false
        toast({
          component: ToastificationContent,
          props: {
            title: 'Error en petición [Lista de compañeros]',
            text: error,
            icon: 'AlertCircleIcon',
            variant: 'danger',
          },
        },
        { timeout: 10000 })
      })
    }

    loadClassmates()

    return {
      // Data
      classmates,
      temporalClassmates,
      shallShowEmailComposeModal,
      personSelected,

      // Filter
      updatedAt,
      currentPage,
      perPage,
      totalItems,
      perPageOptions,
      searchQuery,

      // Loader
      isBusy,
    }
  },
}
/* eslint-disable global-require */
</script>

<style lang="scss" scoped>

</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
